import React from 'react';

function PdfLayout({ children, header, footer }) {
    return (
        <>
            <table
                cellPadding={0}
                cellSpacing={0}
                className="w-full table-fixed print:bg-white"
                // style={{ width: '800px' }}
            >
                <thead className="table-header-group break-inside-avoid">
                    <tr>
                        <th className="w-full h-[70px]">{header}</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td className="">{children}</td>
                    </tr>
                </tbody>
                <tfoot className="hidden print:table-footer-group break-inside-avoid">
                    <tr>
                        <td style={{ width: '800px', height: '104px' }} aria-label="Loading..." />
                    </tr>
                </tfoot>
            </table>

            <div className="hidden print:block fixed bottom-0 left-0 w-full">{footer}</div>
        </>
    );
}

export default PdfLayout;
